// src/components/dashboard-highlights/dashboard-highlights.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment DashboardHighlightsProgressFragment on TravelAgentDashboardProgress {\n    progressBar {\n      accessibilityLabel\n      percent\n      progressDescription\n      title\n    }\n    progressBarNote\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  fragment DashboardHighlightsSubheadingListFragment on TravelAgentDashboardSubheadingList {\n    subheadings\n    labelValues {\n      label\n      value\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  fragment DashboardHighlightsSectionFragment on TravelAgentDashboardSection {\n    heading\n    subheading\n    content {\n      __typename\n      ...DashboardHighlightsProgressFragment\n      ...DashboardHighlightsSubheadingListFragment\n    }\n    cardLink {\n      resource {\n        value\n      }\n      analytics {\n        referrerId\n        linkName\n      }\n      accessibility\n      target\n    }\n    image {\n      url\n      description\n    }\n    clickableLink {\n      text\n      action {\n        resource {\n          value\n        }\n        analytics {\n          referrerId\n          linkName\n        }\n        target\n      }\n    }\n    clickableActionLink {\n      text\n      action\n      analytics {\n        referrerId\n        linkName\n      }\n    }\n    cardActionLink {\n      text\n      action\n      analytics {\n        referrerId\n        linkName\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  query DPReportDownloadQuery($context: ContextInput!) {\n    deferredPaymentReport(context: $context) {\n      uri {\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  query DashboardHighlightsQuery($context: ContextInput!, $dashboardType: DashboardType) {\n    travelAgentDashboard(context: $context, dashboardType: $dashboardType) {\n      heading\n      sections {\n        ...DashboardHighlightsSectionFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
import React4 from "react";
import { gql as gql4, useQuery } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex2 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2 } from "uitk-react-text";
// src/components/dashboard-highlights/__private/__fragments/dashboard-highlights-section.tsx
import React3 from "react";
import { gql as gql3, useLazyQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkCard, UitkCardLink } from "uitk-react-cards";
import { UitkIllustrations } from "uitk-react-illustrations";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLink } from "uitk-react-link";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkHeading, UitkText as UitkText3 } from "uitk-react-text";
// src/components/dashboard-highlights/__private/__fragments/dashboard-highlights-progress.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkProgressBar } from "uitk-react-progress-bar";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
var fragment = gql(_templateObject());
var DashboardHighlightsProgress = function(props) {
    var data = props.data;
    if (!data.progressBar || data.progressBar.percent >= 0 === false) {
        return null;
    }
    var _data_progressBar = data.progressBar, percent = _data_progressBar.percent, progressDescription = _data_progressBar.progressDescription, accessibilityLabel = _data_progressBar.accessibilityLabel, title = _data_progressBar.title;
    var progressBarNote = data.progressBarNote;
    return /* @__PURE__ */ React.createElement(UitkSpacing, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(UitkProgressBar, {
        percent: percent,
        progressDescription: progressDescription || "",
        title: title || "",
        accessibilityLabel: accessibilityLabel
    }), progressBarNote && /* @__PURE__ */ React.createElement(UitkSpacing, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React.createElement(UitkText, null, progressBarNote))));
};
DashboardHighlightsProgress.fragment = fragment;
DashboardHighlightsProgress.displayName = "TravelAgentDashboardProgress";
// src/components/dashboard-highlights/__private/__fragments/dashboard-highlights-subheading-list.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkList, UitkListItem } from "uitk-react-list";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkTable, UitkTableBody, UitkTableCell, UitkTableCellPadding, UitkTableCol, UitkTableColGroup, UitkTableRow } from "uitk-react-tables";
import { UitkText as UitkText2 } from "uitk-react-text";
var fragment2 = gql2(_templateObject1());
var DashboardHighlightsSubheadingList = function(props) {
    var data = props.data;
    var subheadings = data.subheadings, labelValues = data.labelValues;
    if (subheadings.length === 0 && (labelValues === null || labelValues === void 0 ? void 0 : labelValues.length) === 0) {
        return null;
    }
    if (!labelValues) {
        return /* @__PURE__ */ React2.createElement(UitkSpacing2, {
            padding: {
                blockstart: "three"
            }
        }, /* @__PURE__ */ React2.createElement(UitkList, {
            bullet: "no-bullet"
        }, subheadings.map(function(listItem, index) {
            return /* @__PURE__ */ React2.createElement(UitkListItem, {
                key: "sub-heading-list-item-".concat(index)
            }, /* @__PURE__ */ React2.createElement(UitkText2, {
                size: 300
            }, listItem));
        })));
    }
    return /* @__PURE__ */ React2.createElement(UitkSpacing2, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React2.createElement(UitkTable, null, /* @__PURE__ */ React2.createElement(UitkTableColGroup, null, /* @__PURE__ */ React2.createElement(UitkTableCol, {
        inlineSize: "40%"
    }), /* @__PURE__ */ React2.createElement(UitkTableCol, null)), /* @__PURE__ */ React2.createElement(UitkTableBody, null, labelValues.map(function(listItem, index) {
        return /* @__PURE__ */ React2.createElement(UitkTableRow, {
            key: index
        }, /* @__PURE__ */ React2.createElement(UitkTableCell, {
            padding: UitkTableCellPadding.zero
        }, /* @__PURE__ */ React2.createElement(UitkSpacing2, {
            padding: {
                blockstart: "three"
            }
        }, /* @__PURE__ */ React2.createElement("div", null, /* @__PURE__ */ React2.createElement(UitkText2, null, listItem.label)))), /* @__PURE__ */ React2.createElement(UitkTableCell, {
            align: {
                horizontal: "leading"
            },
            padding: UitkTableCellPadding.zero
        }, /* @__PURE__ */ React2.createElement(UitkSpacing2, {
            padding: {
                blockstart: "three"
            }
        }, /* @__PURE__ */ React2.createElement("div", null, /* @__PURE__ */ React2.createElement(UitkText2, null, listItem.value)))));
    }))));
};
DashboardHighlightsSubheadingList.fragment = fragment2;
DashboardHighlightsSubheadingList.displayName = "TravelAgentDashboardSubheadingList";
// src/components/dashboard-highlights/__private/__fragments/dashboard-highlights-section.tsx
var contentComponents = [
    DashboardHighlightsProgress,
    DashboardHighlightsSubheadingList
];
var fragment3 = gql3(_templateObject2(), DashboardHighlightsProgress.fragment, DashboardHighlightsSubheadingList.fragment);
var __DPReportDownloadQuery = gql3(_templateObject3());
var DashboardHighlightsSection = function(props) {
    var data = props.data, id = props.id;
    var context = useBexApi().context;
    var track = useClickTracker();
    var handleClick = React3.useCallback(function() {
        var _data_cardLink;
        var _ref = ((_data_cardLink = data.cardLink) === null || _data_cardLink === void 0 ? void 0 : _data_cardLink.analytics) || {}, referrerId = _ref.referrerId, linkName = _ref.linkName;
        if (referrerId && linkName) {
            track(referrerId, linkName);
        }
    }, [
        track,
        data.cardLink
    ]);
    var tracker = function(analytics) {
        var referrerId = analytics.referrerId, linkName = analytics.linkName;
        track(referrerId, linkName);
    };
    var heading = data.heading, subheading = data.subheading, content = data.content, image = data.image, cardLink = data.cardLink, clickableLink = data.clickableLink, clickableActionLink = data.clickableActionLink, cardActionLink = data.cardActionLink;
    var _useLazyQuery = _slicedToArray(useLazyQuery(__DPReportDownloadQuery, {
        fetchPolicy: "no-cache"
    }), 2), getFile = _useLazyQuery[0], _useLazyQuery_ = _useLazyQuery[1], response = _useLazyQuery_.data;
    React3.useEffect(function() {
        var _response_deferredPaymentReport, _response_deferredPaymentReport_uri;
        if (response === null || response === void 0 ? void 0 : (_response_deferredPaymentReport = response.deferredPaymentReport) === null || _response_deferredPaymentReport === void 0 ? void 0 : (_response_deferredPaymentReport_uri = _response_deferredPaymentReport.uri) === null || _response_deferredPaymentReport_uri === void 0 ? void 0 : _response_deferredPaymentReport_uri.value) {
            window.location.href = response.deferredPaymentReport.uri.value;
        }
    }, [
        response
    ]);
    return /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem, {
        grow: 1,
        minWidth: "third_width"
    }, /* @__PURE__ */ React3.createElement(UitkCard, {
        border: true,
        "data-stid": "taap-dashboard-".concat(id)
    }, /* @__PURE__ */ React3.createElement(UitkLayoutFlex, {
        alignItems: "center"
    }, image && /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem, {
        alignSelf: "center"
    }, /* @__PURE__ */ React3.createElement(UitkLayoutFlex, null, /* @__PURE__ */ React3.createElement(UitkSpacing3, {
        padding: {
            inline: "two"
        }
    }, /* @__PURE__ */ React3.createElement(UitkSpacing3, {
        padding: {
            inline: "three"
        }
    }, /* @__PURE__ */ React3.createElement(UitkIllustrations, {
        url: image.url,
        alt: ""
    }))))), /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem, {
        grow: 1
    }, /* @__PURE__ */ React3.createElement(UitkSpacing3, {
        padding: {
            block: "four",
            inlineend: "three"
        }
    }, /* @__PURE__ */ React3.createElement("div", null, heading && /* @__PURE__ */ React3.createElement(UitkHeading, {
        tag: "h3",
        size: 5
    }, heading), subheading && /* @__PURE__ */ React3.createElement(UitkText3, {
        size: 300
    }, subheading), contentComponents.map(function(Component, index) {
        if (Component.displayName !== (content === null || content === void 0 ? void 0 : content.__typename)) {
            return null;
        }
        return /* @__PURE__ */ React3.createElement(Component, {
            key: index,
            data: content
        });
    }), clickableLink && /* @__PURE__ */ React3.createElement(UitkSpacing3, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React3.createElement(UitkLink, null, /* @__PURE__ */ React3.createElement("a", {
        href: clickableLink.action.resource.value,
        target: clickableLink.action.target === "INTERNAL" /* INTERNAL */  ? "ExpediaInternal" : "ExpediaExternal",
        rel: clickableLink.action.target === "INTERNAL" /* INTERNAL */  ? "" : "noopener noreferrer",
        onClick: function() {
            return tracker(clickableLink === null || clickableLink === void 0 ? void 0 : clickableLink.action.analytics);
        }
    }, clickableLink.text))), (clickableActionLink === null || clickableActionLink === void 0 ? void 0 : clickableActionLink.action) === "DownloadDPReport" /* DownloadDPReport */  && /* @__PURE__ */ React3.createElement(UitkSpacing3, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React3.createElement(UitkLink, null, /* @__PURE__ */ React3.createElement("button", {
        type: "button",
        onClick: function() {
            getFile({
                variables: {
                    context: context
                }
            });
            tracker(clickableActionLink === null || clickableActionLink === void 0 ? void 0 : clickableActionLink.analytics);
        }
    }, clickableActionLink.text))))))), cardLink && /* @__PURE__ */ React3.createElement(UitkCardLink, null, /* @__PURE__ */ React3.createElement("a", {
        "data-testid": "info-card-link-".concat(cardLink.analytics.referrerId),
        "aria-label": heading || "",
        href: cardLink.resource.value,
        onClick: handleClick,
        target: cardLink.target === "INTERNAL" /* INTERNAL */  ? "ExpediaInternal" : "ExpediaExternal",
        rel: cardLink.target === "INTERNAL" /* INTERNAL */  ? "" : "noopener noreferrer"
    }, heading)), cardActionLink && /* @__PURE__ */ React3.createElement(UitkCardLink, null, /* @__PURE__ */ React3.createElement("button", {
        type: "button",
        onClick: function() {
            getFile({
                variables: {
                    context: context
                }
            });
            tracker(cardActionLink.analytics);
        }
    }, "uitk-card-".concat(cardActionLink.text)))));
};
DashboardHighlightsSection.fragment = fragment3;
DashboardHighlightsSection.displayName = "DashboardHighlightsSection";
// src/components/dashboard-highlights/dashboard-highlights.tsx
var __Query = gql4(_templateObject4(), DashboardHighlightsSection.fragment);
var DashboardHighlights = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr;
    var context = useBexApi2().context;
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !data || !data.travelAgentDashboard) {
        return null;
    }
    var _data_travelAgentDashboard = data.travelAgentDashboard, heading = _data_travelAgentDashboard.heading, sections = _data_travelAgentDashboard.sections;
    var Content = sections.map(function(section, index) {
        return /* @__PURE__ */ React4.createElement(DashboardHighlightsSection, {
            key: index,
            data: section,
            id: index
        });
    });
    return /* @__PURE__ */ React4.createElement(React4.Fragment, null, /* @__PURE__ */ React4.createElement(UitkSpacing4, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React4.createElement(UitkHeading2, {
        tag: "h2",
        size: 3
    }, heading)), /* @__PURE__ */ React4.createElement(Viewport, null, /* @__PURE__ */ React4.createElement(ViewSmall, null, /* @__PURE__ */ React4.createElement(UitkSpacing4, {
        padding: {
            block: "six"
        }
    }, /* @__PURE__ */ React4.createElement(UitkLayoutFlex2, {
        space: "three",
        direction: "column"
    }, Content))), /* @__PURE__ */ React4.createElement(ViewMedium, null, /* @__PURE__ */ React4.createElement(UitkSpacing4, {
        padding: {
            block: "six"
        }
    }, /* @__PURE__ */ React4.createElement(UitkLayoutFlex2, {
        space: "three"
    }, Content)))));
};
DashboardHighlights.displayName = "DashboardHighlights";
export { DashboardHighlights };
//# sourceMappingURL=index.js.map